module.exports = __webpack_public_path__ + "static/media/messenger.2762d3fe.svg";